import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAside } from "shared/utils/aside";

function component() {
    const aside = useAside();

    useEffect(() => {
        aside.dismiss({ silent: true });
    }, []);

    return null;
}

/** @public */
export const Route = createFileRoute("/_auth/organization/senders/")({
    component,
});
